import { min } from "d3-array";
import { default as Pie } from "./Pie";
/**
    @class Donut
    @extends Pie
    @desc Extends the Pie visualization to create a donut chart.
*/

var Donut = function (Pie) {
  function Donut() {
    var this$1 = this;
    Pie.call(this);

    this._innerRadius = function () {
      return min([this$1._width - this$1._margin.left - this$1._margin.right, this$1._height - this$1._margin.top - this$1._margin.bottom]) / 4;
    };

    this._padPixel = 2;
  }

  if (Pie) Donut.__proto__ = Pie;
  Donut.prototype = Object.create(Pie && Pie.prototype);
  Donut.prototype.constructor = Donut;
  return Donut;
}(Pie);

export default Donut;